import { render } from "./AttivitaTimesheet.vue?vue&type=template&id=523b9cfa&ts=true"
import script from "./AttivitaTimesheet.vue?vue&type=script&lang=ts"
export * from "./AttivitaTimesheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__